import { Controller } from "stimulus"
import Choices from "choices.js"
import Cleave from "cleave.js"

export default class extends Controller {
  static targets = ["remove", "select", "phone", "ssn"]

  connect() {
    new Cleave(this.phoneTarget, {
      numericOnly: true,
      blocks: [0, 3, 3, 4],
      delimiters: ["(", ") ", "-"],
    })

    if (this.hasSsnTarget) {
      this.ssnTargets.forEach((ssnField) => {
        new Cleave(ssnField, {
          blocks: [3, 2, 4],
          delimiter: "-",
          numericOnly: true,
        })
      })
    }

    this.ownerChoices = JSON.parse(this.element.dataset.owners).map((owner) => {
      return {
        value: owner.id,
        label: `${owner.last_name}, ${owner.first_name}`,
        customProperties: {
          firstName: owner.first_name,
          lastName: owner.last_name,
          email: owner.email,
          title: owner.title,
          phoneNumber: owner.phone,
        },
      }
    })

    const choices = new Choices(this.selectTarget, {
      searchEnabled: true,
      searchResultLimit: 100,
      itemSelectText: "",
      allowHTML: true,
    })

    choices.setChoices(this.ownerChoices, "value", "label")

    const updateOwnerDetails = (choice) => {
      const $details = $(this.selectTarget)
        .closest(".b-onboarding-owner-select")
        .find(".b-onboarding-owner-details")
      $details.addClass("filled")

      const $detailItems = $details.find(".b-onboarding-owner-details-item")
      $detailItems.eq(0).text(choice.customProperties.firstName)
      $detailItems.eq(1).text(choice.customProperties.lastName)
      $detailItems.eq(2).text(choice.customProperties.email)
      $detailItems.eq(3).text(choice.customProperties.title)
      $detailItems.eq(4).text(choice.customProperties.phoneNumber)
    }

    if (this.selectTarget.dataset.selected) {
      choices.setChoiceByValue(this.selectTarget.dataset.selected)
      updateOwnerDetails(choices.getValue())
    }

    this.selectTarget.addEventListener("choice", (e) => {
      updateOwnerDetails(e.detail.choice)
    })
  }

  onRadioChange(e) {
    const $el = $(e.currentTarget)
    const $parent = $el.closest(".b-onboarding-owner")
    $parent.find(".b-onboarding-owner-panel").hide()

    const $visiblePanel = $parent.find(
      ".b-onboarding-owner-" + e.currentTarget.value,
    )

    if ($visiblePanel.length > 0) {
      $visiblePanel.show()
    }

    // Show the SSN field when any owner type is selected
    $parent.find(".b-onboarding-owner-ssn").show()
  }

  onRemove(e) {
    e.preventDefault()

    const $owner = $(this.element)
    const ownerIndex = this.element.dataset.ownerIndex

    // Clear all form fields for this owner
    // Clear radio buttons
    $owner.find('input[type="radio"]').prop("checked", false)

    // Clear text inputs
    $owner.find('input[type="text"]').val("")

    // Clear select (the user dropdown)
    if (this.hasSelectTarget) {
      // Reset the Choices.js select
      const $select = $(this.selectTarget)
      $select.val("")
      // Trigger change to update Choices.js
      this.selectTarget.dispatchEvent(new Event("change"))
    }

    // Clear the owner details display
    $owner.find(".b-onboarding-owner-details").removeClass("filled")
    $owner.find(".b-onboarding-owner-details-item").text("")

    // Hide the panels and SSN field
    $owner.find(".b-onboarding-owner-panel").hide()
    $owner.find(".b-onboarding-owner-ssn").hide()

    // Hide the owner 2 wrapper and show the "Add Another Owner" button
    const $ownersSection = $owner.closest(".b-onboarding-owners-section")
    $ownersSection.find(".b-onboarding-owner-2-wrapper").hide()
    $ownersSection.find(".b-onboarding-add-owner-2-button").show()
  }
}
